// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
// We removed './index.css' because styles are now handled in App.jsx and App.css
import App from './App';
// We removed the reportWebVitals import as it's not used in this project

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// We removed the reportWebVitals(); function call